import { Box, Typography } from "@mui/material";
import React from "react";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import CustomAutoComple from "../../../../../components/CustomAutoComplete";
import CustomButton from "../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../media/images/icons/arrow-left-circle";
import PelakInput from "./PeleakInput";

export default function ArmadaInfo() {
  const loadingTypes = [
    { label: "نوع1", id: 1 },
    { label: "نوع2", id: 2 },
    { label: "نوع3", id: 3 },
  ];
  return (
    <Box
      sx={{
        marginTop: "16px",
        width: "100%",
        backgroundColor: "background.default",
        padding: "16px",
        borderRadius: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "secondary.dark",
          fontSize: "16px",
        }}
      >
        ثبت مشخصات ناوگان
      </Typography>
      <Box
        sx={{
          marginTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            // border: "1px solid gray",
          }}
        >
          <CustomInputLabel required>{"شماره کارت هوشمند"}</CustomInputLabel>
          <CustomInput placHolder="شماره 8 رقمی کارت هوشمند ناوگان را وارد کنید" />
        </Box>
        <Box
          sx={
            {
              // border: "1px solid gray",
            }
          }
        >
          <CustomInputLabel required>{"نوع بارگیری"}</CustomInputLabel>
          <CustomAutoComple
            placHolder="نوع بارگیری را انتخاب کنید"
            options={loadingTypes}
          />
        </Box>
        <Box
          sx={
            {
              // border: "1px solid gray",
            }
          }
        >
          <CustomInputLabel>{"گروه بارگیری"}</CustomInputLabel>
          <Box
            sx={{
              backgroundColor: "primary.light",
              textAlign: "center",
              color: "primary.main",
              padding: "16px 0px",
              borderRadius: "16px",
            }}
          >
            {"-------"}
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: "8px",
            // border: "1px solid gray",
          }}
        >
          <CustomInputLabel required>
            {"پلاک خود را وارد کنید"}
          </CustomInputLabel>

          <PelakInput />
        </Box>
        <CustomButton
          // loading={loading}
          // onClick={formik.handleSubmit}
          flexDirection="row"
          title="تکمیل مرحله و ادامه"
          justifyContent="center"
          bgColor="secondary.main"
          width="100%"
          fSize="16px"
          fontWeight={600}
          px="10px"
          py="10px"
          borderRadius="10px"
          icon2={<ArrowLeftCircle size={32} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
